export default "__VITE_ASSET__31e5978b__"